import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetJnjPaymentListRequest } from '../models/request/jnjPayment/GetJnjPaymentListRequest';

/** Ön Muhasebe > İşlemler > J&J Ödeme Durumu (JnjPaymentController). */
export class JnjPaymentService {
    static async getJnjPaymentListPagingAndFilter(inputObj: GetJnjPaymentListRequest) {
        try {
            console.log('SERVICE CALL - GetJnjPaymentListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/JnjPayment/GetJnjPaymentListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportJnjPaymentList(inputObj: GetJnjPaymentListRequest) {
        try {
            console.log('SERVICE CALL - ExportJnjPaymentList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/JnjPayment/ExportJnjPaymentList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getJnjPaymentStatus() {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/JnjPayment/GetJnjPaymentStatus', {});

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Çekimi arka planda başlatır ve hemen döner; bitişi getJnjPaymentStatus ile izlenir. */
    static async fetchJnjPayments() {
        try {
            console.log('SERVICE CALL - FetchJnjPayments');

            const resp = await axios.post(Helpers.getEndpoint() + '/JnjPayment/FetchJnjPayments', {});

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}
